<template>
    <ui-crud title="Route Plans" subtitle="A list of delivery and collection jobs for a specific day and vehicle."
             :fetch="fetch" :group-by="groupByDate" :pipe-with="pipeItems" ref="crud">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.formatted_date}`"
                :subtitle="`${item.vehicleRegistration}`"
                :metadata="`${item.jobs.length} job`+(item.jobs.length>1?'s':'')"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <route-plans-form :single-column="singleColumn"
                              :add-item="addItem"></route-plans-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <route-plans-form :item="selectedItem" :single-column="singleColumn"
                              :jobs="selectedItem.jobs" :edit="setEditMode"></route-plans-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <route-plans-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" @print="print"
                              :single-column="singleColumn"
                              :add-item="addItem" :search="search"></route-plans-show>
        </template>
    </ui-crud>
</template>

<script>
import {routePlanStore} from "@stores";
import moment from "moment";
import User from "../../../services/User";

export default {
    props: {
        packageId: null,
        admin: Boolean,
    },
    computed: {
        $store() {
            return routePlanStore
        },
    },
    data() {
        return {
            search: '',
            iframe: false,
            singleColumn:false,
        }
    },
    methods: {
        async fetch() {
            await this.$store.init(this.admin);
            User.registerAggregates(this.$store.state.routePlans.map((item) => {
                return {"type": 'RoutePlan', 'id': item.id};
            }), this.updateFromListener)
            return this.$store.state.routePlans;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-\/]+/);
            if (query.length) {
                return this.$store.state.routePlans.filter((route) => {
                    return query.every((token) => {
                        return route.tokens.includes(token);
                    })
                });
            }
            return this.$store.state.routePlans;
        },
        groupByDate(routePlan) {
            let now = new Date();
            let date = new Date(routePlan.date);
            if (now.getDate() == date.getDate() &&
                now.getMonth() == date.getMonth() &&
                now.getFullYear() == date.getFullYear()) {
                return 'Today'
            }
            if (date < now) {
                return 'Previous'
            }
            return 'Scheduled'
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
                document.body.appendChild(this.iframe);
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
        async updateFromListener(data) {
            if (data.aggregate.type === 'RoutePlan') {
                if (['updateAggregate', 'editLockAcquired', 'editLockReleased'].find((a) => a === data.operation)) {
                    this.$store.state.routePlans.find((s) => s.id === data.aggregate.id).reload()
                    if ((data.operation === 'editLockAcquired') && (data.aggregate.data.lockedByConnectionId !== User.connectionId) && this.$refs['crud'].editMode && (data.aggregate.id === this.$refs['crud'].editMode.id)) {
                        this.$refs['crud'].setEditMode(false)
                    }
                }
            }
        },
        resizeHandler() {
            if ((this.$el.clientWidth < 1094) && !this.singleColumn) {
                this.singleColumn = true;
                this.$forceUpdate();
            } else if ((this.$el.clientWidth > 1094) && this.singleColumn) {
                this.singleColumn = false;
                this.$forceUpdate();
            }
        }
    },
    async mounted() {
        window.addEventListener('resize', this.resizeHandler)
        this.resizeHandler();
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.resizeHandler)
        })

    },

}
</script>
